import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "popover"]

  connect() {
    this.isVisible = false
    this.hideTimeout = null
  }

  disconnect() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
    }
  }

  show() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
    
    // Refresh summary data based on current form data
    this.refreshSummaryData()
    
    this.popoverTarget.classList.remove('invisible', 'opacity-0')
    this.popoverTarget.classList.add('visible', 'opacity-100')
    this.isVisible = true
  }

  refreshSummaryData() {
    // Find the quote-securities controller and refresh the counts
    const quoteSecuritiesElement = document.querySelector('[data-controller*="quote-securities"]')
    if (quoteSecuritiesElement) {
      // Try different possible controller identifiers
      let quoteSecuritiesController = this.application.getControllerForElementAndIdentifier(
        quoteSecuritiesElement,
        'oms--quote-securities'
      )
      
      // Fallback to quote-securities if oms--quote-securities not found
      if (!quoteSecuritiesController) {
        quoteSecuritiesController = this.application.getControllerForElementAndIdentifier(
          quoteSecuritiesElement,
          'quote-securities'
        )
      }
      
      if (quoteSecuritiesController && typeof quoteSecuritiesController.updateCounts === 'function') {
        quoteSecuritiesController.updateCounts()
      } else {
        console.log("Quote securities controller not found or updateCounts method not available")
      }
    } else {
      console.log("Quote securities element not found")
    }
  }

  hide() {
    this.hideTimeout = setTimeout(() => {
      this.popoverTarget.classList.remove('visible', 'opacity-100')
      this.popoverTarget.classList.add('invisible', 'opacity-0')
      this.isVisible = false
    }, 100)
  }

  toggle() {
    if (this.isVisible) {
      this.hide()
    } else {
      this.show()
    }
  }
}
